import cookies from '../lib/cookies'

addEventListener('DOMContentLoaded', () => {
	const cookieBar = document.getElementById('cookie-bar') as HTMLDivElement
	if (!cookieBar) {
		return
	}

	const clearAll = () => {
		for (const key of Object.keys(cookies.getAll())) {
			cookies.unset(key)
		}
	}

	// Delete all previous cookies if no option has been set by the user.
	if (!cookies.get('c')) {
		clearAll()
	}

	// Accept.
	cookieBar.querySelector('#accept-cookies').addEventListener('click', () => {
		cookies.set('c', '1')
		cookieBar.remove()
	})

	// Disable.
	cookieBar.querySelector('#reject-cookies').addEventListener('click', () => {
		clearAll()
		cookies.set('c', '0')
		location.reload()
	})
})